// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2qS6_","infoBtn":"quickbooks_infoBtn__9OeCv","formBox":"quickbooks_formBox__3JZeH","formFooter":"quickbooks_formFooter__-nZwj"};